module.exports = __webpack_public_path__ + "images/mmm-05-desktop.png";